import { render } from "./IconStore.vue?vue&type=template&id=7766769d"
import script from "./IconStore.vue?vue&type=script&lang=js"
export * from "./IconStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__